var map = {
	"./10/cover.camera.react.svg": 73470,
	"./10/reload.arrows.svg": 39788,
	"./12/alert.react.svg": 57482,
	"./12/arrow.right.svg": 19964,
	"./12/clock.svg": 73261,
	"./12/copy.svg": 46588,
	"./12/cross.react.svg": 12828,
	"./12/custom-filter.react.svg": 46640,
	"./12/folder.svg": 20759,
	"./12/link.svg": 5139,
	"./12/lock.react.svg": 89613,
	"./12/locked.react.svg": 59509,
	"./12/mail.svg": 53722,
	"./12/mute.react.svg": 90751,
	"./12/pen-edit.react.svg": 44466,
	"./12/person.svg": 90500,
	"./12/planet.react.svg": 48334,
	"./12/plus.svg": 37891,
	"./12/refresh.react.svg": 56145,
	"./12/right-arrow.react.svg": 21114,
	"./12/share.svg": 7350,
	"./12/tick.react.svg": 73835,
	"./16/backup.svg": 6865,
	"./16/button.minus.react.svg": 97570,
	"./16/button.plus.react.svg": 6746,
	"./16/catalog-settings-common.svg": 96050,
	"./16/catalog-settings-data-management.svg": 23273,
	"./16/catalog-settings-integration.svg": 33499,
	"./16/catalog-settings-payment.svg": 55543,
	"./16/catalog-settings-restore.svg": 17687,
	"./16/catalog-settings-security.svg": 37043,
	"./16/catalog-settings-services.svg": 92809,
	"./16/catalog-settings-storage-management.svg": 66168,
	"./16/catalog.accounts.react.svg": 62065,
	"./16/catalog.ai-agents.react.svg": 76366,
	"./16/catalog.archive.react.svg": 19261,
	"./16/catalog.developer.react.svg": 4693,
	"./16/catalog.documents.react.svg": 26689,
	"./16/catalog.favorites.react.svg": 81624,
	"./16/catalog.folder.react.svg": 96889,
	"./16/catalog.guest.react.svg": 2831,
	"./16/catalog.import.react.svg": 25298,
	"./16/catalog.old.share.react.svg": 30823,
	"./16/catalog.portfolio.react.svg": 67019,
	"./16/catalog.private.react.svg": 41574,
	"./16/catalog.projects.react.svg": 69947,
	"./16/catalog.question.react.svg": 77097,
	"./16/catalog.rooms.react.svg": 35767,
	"./16/catalog.settings.react.svg": 98790,
	"./16/catalog.share.small.react.svg": 17717,
	"./16/catalog.shared.outline.svg": 32997,
	"./16/catalog.shared.react.svg": 47538,
	"./16/catalog.spam.react.svg": 14514,
	"./16/catalog.trash.react.svg": 84033,
	"./16/catalog.user.react.svg": 85472,
	"./16/catalog.user.solid.react.svg": 49487,
	"./16/check.round.react.svg": 57098,
	"./16/circle.cross.svg": 44401,
	"./16/clear.react.svg": 7983,
	"./16/copy.react.svg": 55231,
	"./16/cross.react.svg": 16216,
	"./16/custom-filter.react.svg": 49916,
	"./16/dark.svg": 99643,
	"./16/delete-permanently.react.svg": 9081,
	"./16/departments.react.svg": 79857,
	"./16/downgrade.react.svg": 27109,
	"./16/download.react.svg": 7600,
	"./16/duplicate.react.svg": 22787,
	"./16/export-index.react.svg": 80633,
	"./16/export-room-index.react.svg": 36689,
	"./16/horizontal-dots.react.svg": 81093,
	"./16/light.svg": 13939,
	"./16/locked.react.svg": 97742,
	"./16/mark-as-read.react.svg": 62433,
	"./16/move.react.svg": 58511,
	"./16/mute.react.svg": 51323,
	"./16/other-operations.react.svg": 52329,
	"./16/plus.svg": 43751,
	"./16/protected.react.svg": 40390,
	"./16/refresh.react.svg": 25325,
	"./16/shared.link.svg": 81048,
	"./16/top-arrow.react.svg": 26353,
	"./16/trash.react.svg": 10850,
	"./16/upgrade.react.svg": 38476,
	"./16/upload.react.svg": 3923,
	"./16/vertical-dots.react.svg": 28827,
	"./16/wallet.react.svg": 47143,
	"./17/clear.react.svg": 15158,
	"./17/cross.react.svg": 10545,
	"./17/plus.svg": 30780,
	"./17/vertical-dots.react.svg": 7602,
	"./20/catalog-settings-common.svg": 85049,
	"./20/catalog-settings-data-management.svg": 76640,
	"./20/catalog-settings-developer.svg": 80534,
	"./20/catalog-settings-gift.svg": 41892,
	"./20/catalog-settings-import.svg": 35425,
	"./20/catalog-settings-integration.svg": 68438,
	"./20/catalog-settings-payment.svg": 43242,
	"./20/catalog-settings-restore.svg": 64302,
	"./20/catalog-settings-security.svg": 63948,
	"./20/catalog-settings-services.svg": 20338,
	"./20/catalog-settings-storage-management.svg": 94343,
	"./20/catalog.accounts.react.svg": 43456,
	"./20/catalog.ai-agents.react.svg": 87569,
	"./20/catalog.archive.react.svg": 68874,
	"./20/catalog.documents.react.svg": 15058,
	"./20/catalog.favorites.react.svg": 81771,
	"./20/catalog.folder.react.svg": 73656,
	"./20/catalog.guest.react.svg": 29044,
	"./20/catalog.portfolio.react.svg": 89844,
	"./20/catalog.private.react.svg": 64425,
	"./20/catalog.rooms.react.svg": 50236,
	"./20/catalog.shared.outline.svg": 48376,
	"./20/catalog.shared.react.svg": 54875,
	"./20/catalog.trash.react.svg": 8542,
	"./20/catalog.user.react.svg": 29089,
	"./24/archive.svg": 79218,
	"./24/backup.react.svg": 40795,
	"./24/calendar.svg": 29468,
	"./24/cell.svg": 88702,
	"./24/cellCommon.svg": 24225,
	"./24/copy.react.svg": 28570,
	"./24/delete-permanently.react.svg": 33136,
	"./24/diagram.svg": 10767,
	"./24/download.react.svg": 66753,
	"./24/duplicate.react.svg": 65788,
	"./24/ebook.svg": 70966,
	"./24/export-room-index.react.svg": 59442,
	"./24/file.react.svg": 92183,
	"./24/file.svg": 76384,
	"./24/folder.svg": 82502,
	"./24/folderComplete.svg": 37787,
	"./24/folderInProgress.svg": 59606,
	"./24/form.svg": 57068,
	"./24/html.svg": 95817,
	"./24/image.svg": 11031,
	"./24/letter.svg": 69382,
	"./24/mark-as-read.react.svg": 47256,
	"./24/move.react.svg": 52474,
	"./24/pdf.svg": 18586,
	"./24/planet.react.svg": 7479,
	"./24/shared.svg": 13981,
	"./24/slide.svg": 76011,
	"./24/slideCommon.svg": 15688,
	"./24/sound.svg": 50437,
	"./24/text.svg": 53083,
	"./24/trash.react.svg": 99353,
	"./24/upload.react.svg": 3158,
	"./24/video.svg": 61433,
	"./24/word.svg": 44622,
	"./24/wordCommon.svg": 39889,
	"./32/archive.svg": 45207,
	"./32/calendar.svg": 90795,
	"./32/cell.svg": 49349,
	"./32/cellCommon.svg": 162,
	"./32/clock.svg": 73859,
	"./32/clouds.icon.svg": 56970,
	"./32/diagram.svg": 49594,
	"./32/ebook.svg": 71495,
	"./32/file.svg": 58571,
	"./32/fill.out.yourself.svg": 11807,
	"./32/folder.svg": 52093,
	"./32/folderComplete.svg": 77068,
	"./32/folderInProgress.svg": 50449,
	"./32/form.data.collection.svg": 4739,
	"./32/form.svg": 18747,
	"./32/history.icon.svg": 95080,
	"./32/html.svg": 27118,
	"./32/image.svg": 12086,
	"./32/letter.svg": 63737,
	"./32/move.icon.svg": 61541,
	"./32/pdf.svg": 11343,
	"./32/role.based.filling.svg": 71161,
	"./32/room/ai.svg": 35815,
	"./32/room/archive.svg": 43471,
	"./32/room/custom.svg": 80652,
	"./32/room/editing.svg": 65565,
	"./32/room/form.svg": 10243,
	"./32/room/public.svg": 63178,
	"./32/room/template.svg": 55955,
	"./32/room/virtual-data.svg": 58227,
	"./32/service.icon.svg": 56431,
	"./32/share.svg": 8596,
	"./32/shareFileToUsers.svg": 31069,
	"./32/slide.svg": 73606,
	"./32/slideCommon.svg": 65625,
	"./32/sound.svg": 83156,
	"./32/template/collaboration.svg": 57589,
	"./32/template/custom.svg": 12637,
	"./32/template/form.svg": 2530,
	"./32/template/public.svg": 79315,
	"./32/template/virtual-data.svg": 43806,
	"./32/text.svg": 7271,
	"./32/video.svg": 58324,
	"./32/word.svg": 69297,
	"./32/wordCommon.svg": 90297,
	"./64/archive.svg": 34702,
	"./64/calendar.svg": 23936,
	"./64/cell.svg": 1754,
	"./64/cellCommon.svg": 41269,
	"./64/diagram.svg": 54675,
	"./64/ebook.svg": 81594,
	"./64/file.svg": 39452,
	"./64/folder.svg": 64258,
	"./64/folderComplete.svg": 33991,
	"./64/folderInProgress.svg": 58578,
	"./64/form.svg": 92376,
	"./64/html.svg": 27733,
	"./64/image.svg": 92587,
	"./64/letter.svg": 28130,
	"./64/pdf.svg": 21990,
	"./64/slide.svg": 38191,
	"./64/slideCommon.svg": 66244,
	"./64/sound.svg": 79697,
	"./64/text.svg": 95031,
	"./64/video.svg": 17045,
	"./64/word.svg": 19290,
	"./64/wordCommon.svg": 15349,
	"./96/archive.svg": 91913,
	"./96/calendar.svg": 34945,
	"./96/cell.svg": 49843,
	"./96/cellCommon.svg": 25792,
	"./96/diagram.svg": 74456,
	"./96/ebook.svg": 5293,
	"./96/file.svg": 73409,
	"./96/folder.svg": 6955,
	"./96/folderComplete.svg": 16514,
	"./96/folderInProgress.svg": 97819,
	"./96/form.svg": 42097,
	"./96/html.svg": 79864,
	"./96/image.svg": 77584,
	"./96/letter.svg": 83839,
	"./96/pdf.svg": 93801,
	"./96/slide.svg": 52136,
	"./96/slideCommon.svg": 14763,
	"./96/sound.svg": 54846,
	"./96/text.svg": 94214,
	"./96/video.svg": 82682,
	"./96/word.svg": 72815,
	"./96/wordCommon.svg": 76868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56418;